<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <!-- rederizando componente alert -->
                <alert></alert>

                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Usuários do Sistema</b>
                        </h3>
                        <router-link tag="a" class="btn btn-primary pull-right" to="/cadastros/usuarios/novo" v-if="hasPermission('usuario.write')">Novo</router-link>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-12">
                                <input style="width: 100%" class="form-control" placeholder="Busca: Entre com o nome do usuário" name="filtro_pesquisa" ref="filtro_pesquisa" type="text" v-model="filtros.pesquisa" @keyup.enter="getUsers" />
                            </div>
                        </div>
                        <div class="row" style="margin-top:15px">
                            <div class="col-sm-12 table-responsive">
                                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 20%">
                                                Nome
                                                <span @click="sortByKey('name')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'name' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: 15%">
                                                Usuário
                                                <span @click="sortByKey('usuario')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'usuario' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: 20%">Email</th>
                                            <th style="width: 13%">
                                                Nível
                                                <span @click="sortByKey('nivel')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'nivel' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: 20%">
                                                Unidades
                                                <span @click="sortByKey('setor')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'setor' ? `fa fa-sort-amount${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: 12%" v-if="hasPermission('usuario.write')">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.login }}</td>
                                            <td>{{ item.email }}</td>
                                            <td>{{ item.nivel }}</td>
                                            <td>{{ item.unidades | unidades }}</td>
                                            <td v-if="hasPermission('usuario.write')">
                                                <router-link tag="button" class="btn btn-warning btn-sm" :to="'/cadastros/usuarios/atualizacao/' + item.id" title="Editar" v-if="hasPermission('usuario.update')">
                                                    <i class="fa fa-fw fa-edit"></i>
                                                </router-link>
                                                <a class="btn btn-danger btn-sm" @click.prevent="desativarUsuario(item.id, item.name)" title="Desativar" v-if="item.situacao == 1 && hasPermission('usuario.delete')">
                                                    <i class="fa fa-fw fa-times"></i>
                                                </a>
                                                <a class="btn btn-success btn-sm" @click.prevent="ativarUsuario(item.id, item.name)" title="Ativar" v-if="item.situacao == 0 && hasPermission('usuario.delete')">
                                                    <i class="fa fa-fw fa-check"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getUsers">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.box-body -->
                </div>
                <!-- /.box -->
            </div>
            <!-- /.col-md-12 -->
        </div>
        <!-- /.row -->
    </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import Alert from "../../Alert"; // Importando componente alert

export default {
    filters: {
        unidades: function(val) {
            let unidades = "";
            for (let i = 0; i < val.length; i++) {
                unidades += val[i].nome;
                if (i + 1 < val.length) {
                    unidades += ", ";
                }
            }

            return unidades;
        }
    },
    data: () => ({
        filtros: {
            pesquisa: "",
            coluna: null,
            ordem: null
        },
        apiData: {
            data: []
        }
    }),
    mounted() {
        this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
        this.getUsers();
        this.$nextTick(() => {
            this.$refs.filtro_pesquisa.focus();
        });
    },

    methods: {
        sortByKey: function(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getUsers();
        },
        getUsers(page) {
            if (typeof page === "undefined" || typeof page === "object") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            axios
                .get(`${this.$store.state.serverURI}/api/usuario/getAllPaginate`, config)
                .then(response => {
                    this.apiData = response.data;
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        },
        desativarUsuario(id, nome) {
            this.$swal({
                title: `Tem certeza que deseja desativar o usuário "${nome}"?`,
                text: "Obs.: Nenhum dado pode ser apagado permanentemente do sistema!",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    axios
                        .delete(`${this.$store.state.serverURI}/api/usuario/desativar/` + id, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Usuário desativado com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            })
							this.getUsers();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        ativarUsuario(id, nome) {
            this.$swal({
                title: `Tem certeza que deseja ativar o usuário "${nome}"?`,
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/usuario/ativar/` + id, {}, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Usuário ativado com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
							this.getUsers();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        }
    },
    watch: {
        page: function(val) {
            this.getUsers();
        }
    },

    components: {
        Alert
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?f8c8b0d2